import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch('https://infrec.in/php-backend/backend/blog/get-blogs.php')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          const foundBlog = data.blogs.find(b => b.id == id);
          if (foundBlog) {
            setBlog(foundBlog);
          } else {
            setError('Blog not found');
          }
        } else {
          setError('Failed to fetch blogs');
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching blog:', err);
        setError('Error loading blog');
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  if (error || !blog) {
    return <div className="min-h-screen flex items-center justify-center">{error || 'Blog not found'}</div>;
  }

  return (
    <>
      <section className="bg-darkBlue text-white min-h-[30vh] md:min-h-[30vh] flex items-center justify-center" style={{ paddingTop: '0.5rem' }}>
        <div className="max-w-7xl px-4 mx-auto">
          <div className="grid grid-cols-12 items-center justify-center">
            <div className="col-span-12 text-center">
              <div className="py-8">
                <h2 className="text-2xl md:text-[40px] text-center leading-none font-bold pt-12 md:pt-10">
                  {blog.title}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img src={blog.image_url} alt={blog.title} className="w-full h-96 object-cover" />
            <div className="p-8">
              <div className="flex items-center justify-between mb-6">
                <span className="text-sm font-semibold text-blue-600 bg-blue-50 px-3 py-1 rounded">{blog.category}</span>
                <span className="text-sm text-gray-500">{blog.date}</span>
              </div>
              <div className="text-lg text-gray-700 leading-relaxed mb-6 prose prose-lg max-w-none" dangerouslySetInnerHTML={{ __html: blog.content }} />
              <Link to="/blog" className="inline-block text-blue-600 font-semibold hover:text-blue-800 transition-colors">
                ← Back to Blog
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
